module.exports = __webpack_public_path__ + "img/login-v2-dark.933d35c5.svg";